/**
 * The protected sales-demo organization (backend `prisma/demo-constants.ts`).
 *
 * Every row the demo seeder writes uses a deterministic id from one reserved
 * UUID namespace — `DEMO_UUID_NAMESPACE = '00000000-0000-4000-9000-'` — so
 * "is this the demo org?" is a prefix test on the organization id, with no
 * extra API call and no flag that can drift. Staging is where demos run (there
 * is no production yet), so internal-only surfaces that make sense for QA on
 * staging — the floating bug reporter, the first-use tour — stand down for
 * this org only.
 */
export const DEMO_UUID_NAMESPACE = "00000000-0000-4000-9000-";

export function isDemoOrganizationId(
  organizationId: string | null | undefined,
): boolean {
  return (
    typeof organizationId === "string" &&
    organizationId.startsWith(DEMO_UUID_NAMESPACE)
  );
}
